import { SmepEventOnCallPerson } from '@nativewaves/nw-cloud-sdk/smep'

/**
 * What to call an on call person. Only the platform can put a name to a user id — identity refuses to
 * hand one user another's profile — so an unresolved person falls back to the email it did resolve,
 * and keeps their place under the raw id rather than disappearing from the escalation order.
 */
export const onCallPersonLabel = (person: SmepEventOnCallPerson) => person.name || person.email || person.userId

/**
 * Identity hands out the logged in user's platform id as `sub` — the same id an on call entry stores —
 * so the id alone is enough to spot yourself in a list whose names the event list leaves unresolved.
 *
 * @returns the 1-based place in the escalation order, or 0 when the user is not on call.
 */
export const findOnCallPosition = (onCall: SmepEventOnCallPerson[] | undefined, userId: string | undefined) =>
  onCall && userId ? onCall.findIndex((person) => person.userId === userId) + 1 : 0
